/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_End_Other_FailedInputs */

const en_us2_offline_end_other_failed = /** @type {(inputs: Offline_End_Other_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The other workout could not be ended, so nothing was sent. Check your connection and try again.`)
};

const pt_br2_offline_end_other_failed = /** @type {(inputs: Offline_End_Other_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível encerrar o outro treino, então nada foi enviado. Confira sua conexão e tente de novo.`)
};

const es_419_offline_end_other_failed = /** @type {(inputs: Offline_End_Other_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo terminar el otro entrenamiento, así que no se envió nada. Revisa tu conexión e intenta de nuevo.`)
};

const pt_pt2_offline_end_other_failed = /** @type {(inputs: Offline_End_Other_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível terminar o outro treino, por isso nada foi enviado. Verifica a ligação e tenta outra vez.`)
};

const fr_fr2_offline_end_other_failed = /** @type {(inputs: Offline_End_Other_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible de terminer l'autre séance, donc rien n'a été envoyé. Vérifie ta connexion et réessaie.`)
};

const de_de2_offline_end_other_failed = /** @type {(inputs: Offline_End_Other_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das andere Training konnte nicht beendet werden, daher wurde nichts gesendet. Prüfe deine Verbindung und versuch es noch mal.`)
};

const it_it2_offline_end_other_failed = /** @type {(inputs: Offline_End_Other_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile chiudere l'altro allenamento, quindi non è stato inviato nulla. Controlla la connessione e riprova.`)
};

/**
* | output |
* | --- |
* | "The other workout could not be ended, so nothing was sent. Check your connection and try again." |
*
* @param {Offline_End_Other_FailedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const offline_end_other_failed = /** @type {((inputs?: Offline_End_Other_FailedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_End_Other_FailedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_offline_end_other_failed(inputs)
	if (locale === "es-419") return es_419_offline_end_other_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_end_other_failed(inputs)
	if (locale === "fr-FR") return fr_fr2_offline_end_other_failed(inputs)
	if (locale === "de-DE") return de_de2_offline_end_other_failed(inputs)
	if (locale === "it-IT") return it_it2_offline_end_other_failed(inputs)
	return en_us2_offline_end_other_failed(inputs)
});
export { offline_end_other_failed as "offline.end_other_failed" }